"use client";

import { ApexOptions } from "apexcharts";
import dynamic from "next/dynamic";

const ReactApexChart = dynamic(() => import("react-apexcharts"), { ssr: false });

interface MetricCardProps {
  title: string;
  value: string | number;
  change: string;
  changeType: "positive" | "negative" | "neutral";
  chartData: number[];
  info?: boolean;
  showDetails?: boolean;
}

export default function MetricCard({ title, value, change, changeType, chartData, info, showDetails = true }: MetricCardProps) {
  const options: ApexOptions = {
    chart: { type: "area", height: 50, sparkline: { enabled: true } },
    stroke: { curve: "smooth", width: 2 },
    fill: { opacity: 0.2 },
    tooltip: { enabled: false },
    xaxis: { labels: { show: false }, axisBorder: { show: false }, axisTicks: { show: false } },
    yaxis: { show: false },
    grid: { show: false },
    colors: [
      changeType === "positive"
        ? "#22c55e"
        : changeType === "negative"
        ? "#f59e42"
        : "#6B7280"
    ],
  };

  return (
    <div className={`rounded-lg bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 shadow flex flex-col min-w-[180px] ${showDetails ? 'p-4' : 'p-6'}`}>
      <div className="flex items-center justify-between">
        <span className={`font-medium text-gray-800 dark:text-white ${showDetails ? '' : 'text-lg'}`}>{title}</span>
        {info && <span className="ml-2 text-gray-400 dark:text-gray-500 cursor-pointer">i</span>}
      </div>
      <div className={`font-bold mt-2 text-gray-900 dark:text-white ${showDetails ? 'text-2xl' : 'text-4xl flex-grow flex items-center justify-center'}`}>{value}</div>
      {showDetails && (
        <>
          <div className={`text-sm mt-1 ${
            changeType === "positive"
              ? "text-green-600 dark:text-green-400"
              : changeType === "negative"
              ? "text-orange-600 dark:text-orange-400"
              : "text-gray-500 dark:text-gray-400"
          }`}>
            {change}
          </div>
          <div className="mt-2">
            <ReactApexChart options={options} series={[{ data: chartData }]} type="area" height={50} />
          </div>
        </>
      )}
    </div>
  );
} 